<template>
  <div class="quick-estimate">
    <h2>簡易見積り</h2>
    <table class="quick-estimate-table">
      <tr>
        <td>選択したプラン</td>
        <td>
          ({{orderTypeJa[order.order_type]}}/{{mealTypeJa[order.meal_type]}}) {{order.plan_name}}
          {{order.plan_price | currency}} x {{order.quantity}}人 = {{order.quantity * order.plan_price | currency}}
        </td>
      </tr>
      <tr v-if="order.drink_sets.length > 0">
        <td>ドリンクセット</td>
        <td>
          <ul>
            <li v-for="drink_set in order.drink_sets">
              {{drink_set.name}}
              {{drink_set.price | currency}} x {{drink_set.quantity}}セット = {{drink_set.quantity * drink_set.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="singleDrinks.length > 0">
        <td>ドリンク(単品)</td>
        <td>
          <ul>
            <li v-for="drink in singleDrinks">
              {{drink.name}}
              {{drink.price | currency}} x {{drink.quantity}}{{drink.unit_name}} = {{drink.quantity * drink.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="equipments.length > 0">
        <td>備品</td>
        <td>
          <ul>
            <li v-for="equipment in equipments">
              {{equipment.name}}
              {{equipment.price | currency}} x {{equipment.quantity}}{{equipment.unit_name}} = {{equipment.quantity * equipment.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="calculationResult.drink_plans.length > 0">
        <td>ドリンクプラン</td>
        <td>
          <ul>
            <li v-for="drinkPlan in calculationResult.drink_plans">
              {{drinkPlan.name}}
              {{drinkPlan.price | currency}} x {{drinkPlan.quantity}}{{drinkPlan.unit_name}} =
              {{drinkPlan.quantity * drinkPlan.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="calculationResult.dishes.length > 0">
        <td>追加料理</td>
        <td>
          <ul>
            <li v-for="dish in calculationResult.dishes">
              {{dish.name}}
              {{dish.price | currency}} x {{dish.quantity}}{{dish.unit_name}} = {{dish.quantity * dish.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="order.use_tablecloth || order.use_exothermic_agent || order.use_plate">
        <td>オプション</td>
        <td>
          <ul>
            <li v-if="order.use_plate">
              取皿セット: {{calculationResult.plate.price | currency}}
            </li>
            <li v-if="order.use_tablecloth">
              テーブルクロス: {{calculationResult.tablecloth.price | currency}}
            </li>
            <li v-if="order.use_exothermic_agent">
              発熱剤: {{calculationResult.exothermic_agent.price | currency}}
            </li>
          </ul>
        </td>
      </tr>
      <tr v-if="order.order_type === 'catering'">
        <td>スタッフ派遣料</td>
        <td>
          <ul>
            <li>
              {{calculationResult.worker.price | currency}}
              <span v-if="calculationResult.drink_plans.length > 0">
                (バーテンダー料金)
              </span>
              <span v-else>
                (設置・撤収料金)
              </span>
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>送料</td>
        <td>{{calculationResult.delivery_price | currency}} <span v-if="order.city">({{order.prefecture}}{{order.city}}への送料)</span></td>
      </tr>

      <tr>
        <td>小計金額</td>
        <td>{{calculationResult.normal_tax_rate.sub_total + calculationResult.reduced_tax_rate.sub_total | currency}}</td>
      </tr>

      <tr>
        <td>消費税</td>
        <td>{{calculationResult.normal_tax_rate.tax + calculationResult.reduced_tax_rate.tax | currency}}</td>
      </tr>

      <tr>
        <td>合計金額</td>
        <td>{{calculationResult.total_price | currency}}</td>
      </tr>
    </table>

    <table class="mt-2 tax-table">
      <tr class="reduced-tax-rate" v-if="order.order_type === 'delivery'">
        <td>8%対象</td>
        <td>{{calculationResult.reduced_tax_rate.sub_total | currency }}</td>
        <td>消費税</td>
        <td>{{calculationResult.reduced_tax_rate.tax | currency }}</td>
      </tr>
      <tr class="normal-tax-rate">
        <td>10%対象</td>
        <td>{{calculationResult.normal_tax_rate.sub_total | currency }}</td>
        <td>消費税</td>
        <td>{{calculationResult.normal_tax_rate.tax | currency }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { orderTypeJa, mealTypeJa }  from '../../utilities/locale';
  export default {
    props: {
      order: Object,
      calculationResult: Object
    },
    data: function () {
      return {
        orderTypeJa,
        mealTypeJa
      }
    },
    methods: {
    },
    updated() {
    },
    computed: {
      singleDrinks() {
        return this.order.drinks.filter(option => option.kind !== 'other');
      },
      equipments() {
        return this.order.drinks.filter(option => option.kind === 'other');
      },
    }
  } </script>

